import { render, staticRenderFns } from "./ExtensivLogs.vue?vue&type=template&id=487669e8"
import script from "./ExtensivLogs.vue?vue&type=script&lang=js"
export * from "./ExtensivLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports